import { render, staticRenderFns } from "./ProductsCRM.vue?vue&type=template&id=24739670&scoped=true"
import script from "./ProductsCRM.vue?vue&type=script&lang=js"
export * from "./ProductsCRM.vue?vue&type=script&lang=js"
import style0 from "./ProductsCRM.vue?vue&type=style&index=0&id=24739670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24739670",
  null
  
)

export default component.exports